import BasicLayoutV2 from '@/layouts/BasicV2';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

import {taskCenterConfig} from '../layouts/config/leftSidebar';

const importEnv = require('./_import_' + process.env.NODE_ENV);

export default [
    {
        path: '/user/:userid/taskCenter/image/gallery',
        name: 'taskCenterImageGallery',
        meta: {
            authorizedRole: 'digital_human_list',
            title: '图片任务',
            isShowGalleryView: true
        },
        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
            {name: 'myCreation', loader: () => import('../model/myCreation')}
        ]),
        component: importEnv('TaskCenter/image/Gallery')
    },
    {
        path: '/user/:userid/taskCenter',
        name: 'taskCenter',
        component: BasicLayoutV2,
        children: [
            {
                path: '/',
                redirect: {
                    name: 'videoTaskV2'
                }
            },
            {
                path: 'center',
                name: 'taskCenterWork',
                // component: importEnv('TaskCenter/Index'),
                component: () => import('@/layouts/ContentLayout'),
                props: {
                    leftNavConfig: taskCenterConfig
                },
                children: [
                    {
                        path: 'videoTask',
                        name: 'videoTask',
                        redirect: {
                            name: 'videoTaskV2'
                        }
                    },
                    {
                        path: 'videoTaskV2',
                        name: 'videoTaskV2',
                        meta: {
                            authorizedRole: 'digital_human_list',
                            title: '视频任务',
                            titleTip: '系统默认只保留最近3个月的任务，请尽快保存到视频库。'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')}
                        ]),
                        component: importEnv('TaskCenter/video/Index')
                    },
                    {
                        path: 'imageTask',
                        name: 'imageTask',
                        redirect: {
                            name: 'imageTaskV2'
                        }
                    },
                    {
                        path: 'imageTaskV2',
                        name: 'imageTaskV2',
                        meta: {
                            authorizedRole: 'digital_human_list',
                            title: '图片任务',
                            isShowGalleryView: true
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                            {name: 'myCreation', loader: () => import('../model/myCreation')}
                        ]),
                        component: importEnv('TaskCenter/image/Index')
                    },
                    {
                        path: 'textTask',
                        name: 'textTask',
                        redirect: {
                            name: 'textTaskV2'
                        }
                    },
                    {
                        path: 'textTaskV2',
                        name: 'textTaskV2',
                        meta: {
                            authorizedRole: 'digital_human_list',
                            title: '文案任务',
                            titleTip: '系统默认仅保留最近3个月的文案任务，请尽快保存到文案库。'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook(
                            [
                                {name: 'TextCreate', loader: () => import('../model/TextCreate')}
                            ]
                        ),
                        component: importEnv('TaskCenter/text/Index')
                    },
                    {
                        path: 'scriptTask',
                        name: 'scriptTask',
                        redirect: {
                            name: 'scriptTaskV2'
                        }
                    },
                    {
                        path: 'scriptTaskV2',
                        name: 'scriptTaskV2',
                        meta: {
                            authorizedRole: 'digital_human_list',
                            title: '脚本任务',
                            titleTip: '系统默认仅保留最近3个月的脚本任务，请尽快保存到脚本库。'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'TextCreate', loader: () => import('../model/TextCreate')}
                        ]),
                        component: importEnv('TaskCenter/script/Index')
                    }
                ]
            }
        ]
    }
];
